import axios from "@axios";
import { hasError } from "@/utils/utils";
export default {
  namespaced: true,
  state: {
    feedbackContent: "",
    loading: false,
    isModalVisible: false,
    modalTitle: "ردود الوزارة",
  },
  getters: {
    feedbackContent(state) {
      return state.feedbackContent;
    },
    loading(state) {
      return state.loading;
    },
    isModalVisible(state) {
      return state.isModalVisible;
    },
    modalTitle(state) {
      return state.modalTitle;
    },
  },

  mutations: {
    setFeedbackContent(state, payload) {
      state.feedbackContent = payload;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
    setModalVisibility(state, payload) {
      state.isModalVisible = payload;
    },
  },
  actions: {
    async sendFeedback({ commit }, { ep, form }) {
      commit("setLoading", true);
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axios.post(ep, form);
          const err = hasError(res.status);
          if (err) throw err;
          resolve();
        } catch (err) {
          reject(err);
        } finally {
          commit("setLoading", false);
        }
      });
    },
    async fetchFeedbackContent({ commit }, ep) {
      commit("setLoading", true);
      try {
        const res = await axios.get(ep);
        if (res.data.data) {
          commit("setFeedbackContent", res.data.data.content);
        } else {
          commit("setFeedbackContent", "");
        }
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },
  },
};
